import { Link } from "react-router-dom";
import { List, ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import { Inbox as InboxIcon } from "@material-ui/icons";
import React from "react";

function Sidebar() {
  return (
    <List>
      {["Contatos"].map((text) => (
        <ListItem button key={text}>
          <ListItemIcon>
            <InboxIcon />
          </ListItemIcon>

          <Link to="/app">
            <ListItemText primary={text} />
          </Link>
        </ListItem>
      ))}
    </List>
  );
}

export default Sidebar;
